import { CALENDAR_SETTINGS_TASK_TYPES_SEARCH_THRESHOLD } from '../../CalendarSettings.constants'

function getCalendarSettingsTaskTypeSearchName(type) {
  return type.name.toLocaleLowerCase()
}

export function getIsCalendarSettingsTaskTypesEmpty(taskTypes) {
  return taskTypes.length === 0
}

export function getHasCalendarSettingsTaskTypesSearch(taskTypes) {
  return taskTypes.length > CALENDAR_SETTINGS_TASK_TYPES_SEARCH_THRESHOLD
}

export function getCalendarSettingsVisibleTaskTypes({ search, taskTypes }) {
  const query = search.trim().toLocaleLowerCase()

  return taskTypes.filter(type =>
    getCalendarSettingsTaskTypeSearchName(type).includes(query)
  )
}
